import React from 'react'
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardFooter from 'components/Card/CardFooter'
import NavLink from "react-bootstrap/NavLink"
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
const useStyles = makeStyles(styles);


function LinkCopierCard(props) {

    const classes = useStyles();

    const {title, subtitle, link} = props

    const [showCopyLink, setCopyLink] = React.useState(false);
    function handleWidgetLinkClick(e) {
        e.preventDefault()
        var input = document.createElement('input');
        input.setAttribute('value', link);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        setCopyLink(true);

        setTimeout(function() {
            setCopyLink(false);
        }, 2000);
    }

    return (
        <Card>
            <CardHeader color="primary" icon>
            <h3 className={classes.cardTitle}>
                <small>{title}</small>
            </h3>
            <p className={classes.cardCategory}>{subtitle}</p>
            <p className={classes.cardCategory}>Click to copy your link</p>
            </CardHeader>
            <CardFooter stats>
            <Tooltip open={showCopyLink} title={showCopyLink ? "Copied!" : "Copy"}>
                <NavLink id="widgetLink" href="" onClick={handleWidgetLinkClick}>
                    <div>{link}</div>
                {/* {instructor && instructor.widgetName && (
                    <div>
                        sutrapro.com/{instructor.widgetName}
                    </div>
                )} */}
                </NavLink>
            </Tooltip>
            </CardFooter>
        </Card>
    )
}

export default LinkCopierCard